<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon> Categorias</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Categorias</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body">
    <div
      class="row filtros-header justify-content-end"
      style="border-bottom: 1px solid #dee2e6"
    >
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="showNew(); showModalAgregar()"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 150px">
        <div class="md-form mb-0">
          <input
            value=""
            type="text"
            id="bcategoria"
            [(ngModel)]="nombre"
            class="form-contcategoria"
            placeholder="Categorias"
            required
            #categoria
          />
          <label for="categoria">Categorias</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6"
  >
    <div></div>
    <button
      mdbBtn
      type="button"
      color="secondary"
      (click)="obtenerDatosSegunFiltro(nombre)"
      size="sm"
      mdbWavesEffect
    >
      <mdb-icon fas icon="search"></mdb-icon>Buscar
    </button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Categoria</th>
            <th scope="col">Orden</th>
            <th scope="col">Fecha de creación</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngIf="!categoria_moduloList || categoria_moduloList.length === 0"
          >
            <td colspan="5" style="text-align: center">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let cat of categoria_moduloList">
            <td>{{ cat.nombre }}</td>
            <td>{{ cat.orden }}</td>
            <td>{{ cat.fecha_creacion | date: "dd/MM/yyyy" }}</td>
            <td>
              <div *ngIf="cat.activado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!cat.activado">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button
                mdbBtn
                type="button"
                size="sm"
                color="info"
                mdbWavesEffect
                class="btn-actions-sm"
                (click)="showForEdit(cat); showModalModificar()"
                mdbTooltip="Editar"
                placement="right"
              >
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button
                *ngIf="cat.activado"
                mdbBtn
                type="button"
                size="sm"
                color="primary"
                mdbWavesEffect
                class="btn-actions-sm"
                (click)="permitirCambioEstado(cat)"
                mdbTooltip="Desactivar"
                placement="right"
              >
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button
                *ngIf="!cat.activado"
                mdbBtn
                type="button"
                size="sm"
                color="success"
                mdbWavesEffect
                class="btn-actions-sm"
                (click)="permitirCambioEstado(cat)"
                mdbTooltip="Activar"
                placement="right"
              >
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar categoria -->
<div
  style="overflow-y: auto"
  mdbModal
  #agregarCategorias="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  categoriae="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" categoriae="document">
    <div class="modal-content">
      <form
        [formGroup]="formulario"
        (ngSubmit)="insertar(moduloCategoriaList); agregarCategorias.hide()"
      >
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="agregarCategorias.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de categoria
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label
                  >Inactivo<input
                    formControlName="activado"
                    type="checkbox"
                    checked
                  /><span class="lever"></span>Activo</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input
                  value=""
                  formControlName="nombre"
                  type="text"
                  id="acategoria"
                  class="form-contcategoria"
                  placeholder="Categoria"
                  required
                  #categoria
                  maxlength="50"
                />
                <label for="categoria">Categoria</label>
                <div
                  *ngIf="
                    formulario.get('nombre').invalid &&
                    (formulario.get('nombre').dirty ||
                      formulario.get('nombre').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('required')"
                    >El Nombre es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('maxlength')"
                    >El Nombre no puede superar los 50 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('minlength')"
                    >El Nombre debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  value=""
                  formControlName="icono"
                  type="text"
                  id="aicono"
                  class="form-contcategoria"
                  placeholder="Icono"
                  required
                  #icono
                  maxlength="30"
                />
                <label for="icono">Icono</label>
                <div
                  *ngIf="
                    formulario.get('icono').invalid &&
                    (formulario.get('icono').dirty ||
                      formulario.get('icono').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('icono').hasError('required')"
                    >El Icono es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('icono').hasError('maxlength')"
                    >El Icono no puede superar los 30 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('icono').hasError('minlength')"
                    >El Icono debe tener como mínimo 3 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  value=""
                  formControlName="orden"
                  type="number"
                  step="1"
                  id="aorden"
                  placeholder="Orden"
                  required
                  #rol
                  maxlength="50"
                />
                <label for="veorden">Orden</label>
                <div
                  *ngIf="
                    formulario.get('orden').invalid &&
                    (formulario.get('orden').dirty ||
                      formulario.get('orden').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('orden').hasError('required')"
                    >El Orden es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('orden').hasError('min')"
                    >El Orden no puede ser cero.</mdb-error
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="modulo"
                  label="Modulo"
                  [options]="optionsModulo"
                  placeholder="Modulo"
                  [filterEnabled]="true"
                >
                </mdb-select>
              </div>
            </div>
            <div class="col">
              <button
                type="button"
                mdbBtn
                color="info"
                mdbWavesEffect
                (click)="agregarModulo()"
              >
                Agregar
              </button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Módulo</th>
                  <th scope="col">EndPoint</th>
                  <th scope="col">Orden</th>
                  <th scope="col">Fecha de asignación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngIf="
                    !moduloCategoriaList || moduloCategoriaList.length === 0
                  "
                >
                  <td colspan="7" style="text-align: center">
                    Agregué Modulos
                  </td>
                </tr>
                <tr *ngFor="let mod of moduloCategoriaList; let i = index">
                  <td>{{ mod.nombre }}</td>
                  <td>{{ mod.endpoint }}</td>
                  <td>{{ mod.orden }}</td>
                  <td>{{ mod.fecha_creacion | date: "dd/MM/yyyy" }}</td>
                  <td>
                    <button
                      mdbBtn
                      type="button"
                      size="sm"
                      color="primary"
                      mdbWavesEffect
                      class="btn-actions-sm"
                      (click)="eliminarModulo(i)"
                    >
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="agregarCategorias.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            class="btn btn-secondary waves-light"
            mdbWavesEffect
            type="submit"
            [disabled]="formulario.invalid"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL editarCategorias -->
<div
  style="overflow-y: auto"
  mdbModal
  #editarCategorias="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  categoriae="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" categoriae="document">
    <div class="modal-content">
      <form
        [formGroup]="formulario"
        (ngSubmit)="actualizar(moduloCategoriaList); editarCategorias.hide()"
      >
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="editarCategorias.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de categoria
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label
                  >Inactivo<input
                    formControlName="activado"
                    type="checkbox"
                    checked
                  /><span class="lever"></span>Activo</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input
                  value=""
                  formControlName="nombre"
                  type="text"
                  id="ecategoria"
                  class="form-contcategoria"
                  placeholder="Categoria"
                  required
                  #categoria
                  maxlength="50"
                />
                <label for="categoria">Categoria</label>
                <div
                  *ngIf="
                    formulario.get('nombre').invalid &&
                    (formulario.get('nombre').dirty ||
                      formulario.get('nombre').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('required')"
                    >El Nombre es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('maxlength')"
                    >El Nombre no puede superar los 50 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('minlength')"
                    >El Nombre debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  value=""
                  formControlName="icono"
                  type="text"
                  id="eicono"
                  class="form-contcategoria"
                  placeholder="Icono"
                  required
                  #icono
                  maxlength="30"
                />
                <label for="icono">Icono</label>
                <div
                  *ngIf="
                    formulario.get('icono').invalid &&
                    (formulario.get('icono').dirty ||
                      formulario.get('icono').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('icono').hasError('required')"
                    >El Icono es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('icono').hasError('maxlength')"
                    >El Icono no puede superar los 30 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('icono').hasError('minlength')"
                    >El Icono debe tener como mínimo 3 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  value=""
                  formControlName="orden"
                  type="number"
                  step="1"
                  id="eorden"
                  placeholder="Orden"
                  required
                  #rol
                  maxlength="50"
                />
                <label for="veorden">Orden</label>
                <div
                  *ngIf="
                    formulario.get('orden').invalid &&
                    (formulario.get('orden').dirty ||
                      formulario.get('orden').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('orden').hasError('required')"
                    >El Orden es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('orden').hasError('min')"
                    >El Orden no puede ser cero.</mdb-error
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="modulo"
                  label="Modulo"
                  [options]="optionsModulo"
                  placeholder="Modulo"
                  [filterEnabled]="true"
                >
                  <option *ngFor="let p of moduloList"></option>
                </mdb-select>
              </div>
            </div>
            <div class="col">
              <button
                type="button"
                mdbBtn
                color="info"
                mdbWavesEffect
                (click)="agregarModulo()"
              >
                Agregar
              </button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Módulo</th>
                  <th scope="col">EndPoint</th>
                  <th scope="col">Orden</th>
                  <th scope="col">Fecha de asignación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngIf="
                    !moduloCategoriaList || moduloCategoriaList.length === 0
                  "
                >
                  <td colspan="7" style="text-align: center">
                    Agregué Modulos
                  </td>
                </tr>
                <tr *ngFor="let mod of moduloCategoriaList; let i = index">
                  <td>{{ mod.nombre }}</td>
                  <td>{{ mod.endpoint }}</td>
                  <td>{{ mod.orden }}</td>
                  <td>{{ mod.fecha_creacion | date: "dd/MM/yyyy" }}</td>
                  <td>
                    <button
                      mdbBtn
                      type="button"
                      size="sm"
                      color="primary"
                      mdbWavesEffect
                      class="btn-actions-sm"
                      (click)="eliminarModulo(i)"
                    >
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="editarCategorias.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            class="btn btn-secondary waves-light"
            mdbWavesEffect
            type="submit"
            [disabled]="formulario.invalid"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
